import { generateRandomString } from '../utils/stringHelper';
import { HttpClient } from '../utils/httpClient';

const PATH = {
    cart: '/cart',
};

const addToCart = (payload, callback, error, loader) => {
    const { start, stop } = loader(generateRandomString(5));
    start();
    return HttpClient.post(`${PATH.cart}`, payload).then(callback).catch(error).finally(stop);
};

const removeFromCart = (payload, callback, error, loader) => {
    const { start, stop } = loader(generateRandomString(5));
    start();
    return HttpClient.post(`${PATH.cart}/remove`, payload).then(callback).catch(error).finally(stop);
};

const getCartSummary = (callback, error, loader) => {
    const { start, stop } = loader(generateRandomString(5));
    start();
    return HttpClient.get(`${PATH.cart}/cartSummary`).then(callback).catch(error).finally(stop);
};

const getAllCartItems = (callback, error, loader) => {
    const { start, stop } = loader(generateRandomString(5));
    start();
    return HttpClient.get(`${PATH.cart}`).then(callback).catch(error).finally(stop);
};

export const CartService = {
    getAllCartItems,
    removeFromCart,
    addToCart,
    getCartSummary
};